export default "__VITE_ASSET__DW57_Bjp__"